module.exports = () => {
    require('datatables');
    $('table.dataTable').dataTable({
        "oLanguage": {
            sSearch: "Pesquisar por:",
            sLengthMenu: "Mostrar &nbsp; _MENU_ &nbsp; registros por página",
            sInfo: "Mostrando de <b>_START_</b> até <b>_END_</b> de um total de <b>_TOTAL_</b> registros",
            sInfoEmpty: "Sem registros para mostrar",
            sZeroRecords: "Nenhum Registro encontrado",
            sInfoFiltered: "(filtrando de _MAX_ registros)",
            oPaginate: { sFirst: "Primeiro", sLast: "Último", sNext: "Próximo", sPrevious: "Anterior" },
        }
    });

    require('jquery-mask-plugin');
    let fillFieldForm = require('../../../helpers/fill-fields-form');

    let $inputTelefone = $('input[name="telefone"]');
    $inputTelefone.keyup(function () {
        if ($inputTelefone.val().length === 15) {
            $inputTelefone.mask('(00) 90000-0000');
        } else {
            $inputTelefone.mask('(00) 0000-00000');
        }
    }).trigger('keyup');

    let $inputCNPJ = $('input[name="cnpj"]');
    $inputCNPJ.mask('00.000.0000/0000-00');

    $('body').on('click', 'table tr [data-table-actions] a[data-action], button.btn[data-action]', function (e) {
        e.preventDefault();

        let $this = $(this);
        let $targetModal = $($this.data('target'));
        let $modalTitulo = $targetModal.find('[data-modal-titulo]');
        let $ocultData = $this.closest('[data-table-actions]').find('[data-ocult-data]');

        let arrayCamposTipo = {
            input: {
                data: [
                    'id',
                    'nome',
                    'cnpj',
                    'email',
                ],
                attr: {
                    readonly: $this.data('action') == 'ver'
                }
            },
            select: {
                data: [
                    'nivel_acesso',
                ],
                attr: {
                    readonly: $this.data('action') == 'ver'
                }
            },
            span: {
                data: [
                    'id',
                    'nome',
                    'cnpj',
                    'email',
                ],
                typeFill: 'html'
            }
        }
        fillFieldForm(arrayCamposTipo, $ocultData, $targetModal);

        let tituloAction = 'Vendo';
        let nomeRegistro = $ocultData.find(
            `input[name="nome"]`).val();
        switch ($this.data('action')) {
            case 'ver':
                tituloAction = `Vendo: <b>${nomeRegistro}</b>`;
                break;

            case 'novo':
                tituloAction = 'Criando <b>novo</b> registro.';
                break;

            case 'editar':
                tituloAction = `Editando: <b>${nomeRegistro}</b>`;
                break;

            case 'remover':
                tituloAction = `<b class="text-danger">Você está prestes a remover:  ${nomeRegistro}</b>`;
                break;
        }
        $modalTitulo.html(tituloAction);

        $targetModal.modal('show');
    });


};
